// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_base_printable__SiQCk","nonPrintable":"styles_base_nonPrintable__nVfd0","icon":"styles_base_icon__kQkLj"};